export const contactMessageSent = ({ contactMessageSent }) => contactMessageSent
